import { Component } from "preact";

import style from "./index.scss";

import clsx from "clsx";

import CONSTANTS from "../../const";

import { windowModeEnum } from "../../enums";

export default class Settings extends Component {
  state = {
    orientation: ["landscape", "portrait"],
    deviceTypes: ["duo", "neo"],
    isSettingsVisible: false
  };

  onInput = evt => {
    let name = evt.target.name;
    let value = evt.target.value
    if( name === 'windowMode') {
      value = +value
    }
    let setting = {
      [name]:  value
    };
    this.props.updateDeviceSettings(setting);
  };

  toggleSettings = () => {
    this.setState({ isSettingsVisible: !this.state.isSettingsVisible });
  };
  render(props, state) {
    return (
      <nav
        class={clsx(
          style.settings,
          state.isSettingsVisible === true && style.shown
        )}
      >
        <button class={style.toggleMenu} onClick={this.toggleSettings}>
          {/* { state.isSettingsVisible === true ?'hide' : 'show' } settings */}
          ⚙️ & 💡
        </button>
        <div class={style.group}>
          <h5>Device Type</h5>
          {state.deviceTypes.map(t => (
            <div class={style.control}>
              <input
                type="radio"
                id={t}
                name="deviceType"
                value={t}
                checked={props.deviceType === t}
                onChange={this.onInput}
              />
              <label for={t}>Surface {t}</label>
            </div>
          ))}
        </div>
        <div class={style.group}>
          <h5>Device Orientation</h5>
          {state.orientation.map(t => (
            <div class={style.control}>
              <input
                type="radio"
                id={t}
                name="orientation"
                value={t}
                checked={props.orientation === t}
                onChange={this.onInput}
              />
              <label for={t}>{t}</label>
            </div>
          ))}
        </div>

        <div class={style.group}>
          <h5>Browser mode</h5>
          {props.orientation === "landscape" ? (
            <div class={style.btnGroup}>
              <button
                name="windowMode"
                value={windowModeEnum.left}
                class={
                  props.windowMode === windowModeEnum.left && style.selected
                }
                onClick={this.onInput}
              >
                Left
              </button>
              <button
                name="windowMode"
                value={windowModeEnum.spanning}
                class={
                  props.windowMode === windowModeEnum.spanning && style.selected
                }
                onClick={this.onInput}
              >
                Spanning
              </button>
              <button
                name="windowMode"
                value={windowModeEnum.right}
                class={
                  props.windowMode === windowModeEnum.right && style.selected
                }
                onClick={this.onInput}
              >
                Right
              </button>
            </div>
          ) : (
            <div class={style.btnGroup}>
              <button
                name="windowMode"
                value={windowModeEnum.top}
                class={
                  props.windowMode === windowModeEnum.top && style.selected
                }
                onClick={this.onInput}
              >
                Top
              </button>
              <button
                name="windowMode"
                class={style.selected}
                value={windowModeEnum.spanning}
                class={
                  props.windowMode === windowModeEnum.spanning && style.selected
                }
                onClick={this.onInput}
              >
                Spanning
              </button>
              <button
                name="windowMode"
                value={windowModeEnum.bottom}
                class={
                  props.windowMode === windowModeEnum.bottom && style.selected
                }
                onClick={this.onInput}
              >
                Bottom
              </button>
            </div>
          )}
        </div>
        <p>
          Surface {props.deviceType} current screen width is{" "}
          {CONSTANTS[props.deviceType][props.orientation].width} and height is{" "}
          {CONSTANTS[props.deviceType][props.orientation].height} in CSS pixels.
        </p>
        <p>
          Device zoom is <strong>{props.deviceZoom}</strong> to ensure it fits
          within your viewport
        </p>
      </nav>
    );
  }
}
